// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.message-bar[data-v-a1c0dccc] {\n  position: fixed;\n  top: 0;\n  left: 50%;\n  width: 50%;\n  min-height: 50px;\n  z-index: 9999;\n  margin-left: -25%;\n}\n", ""]);
// Exports
module.exports = exports;
